{
  "register-success-page": {
    "buttons": {
      "start": "Začněme"
    },
    "text": {
      "account-created": "Vytvořený účet",
      "account-created-hint": "Váš účet je vytvořen! Nyní se můžete přihlásit a využívat náš rezervační systém."
    }
  }
}
